module.exports = __webpack_public_path__ + "img/HOME_CLOCK_IN.9af00368.svg";